// export default function storeEmbeddedValues (...embeddedValues) {
//   return {
//     type: 'DATA_CONNECTOR_STORE_EMBEDDED_VALUES',
//     payload: embeddedValues,
//   };
// }
import operations from 'rlink-collections/operations';
import _referencesAndReferenceValues from 'rlink-data-connector/storage/_referencesAndReferenceValues';
import {values} from 'rlink-data-connector/storage/collections';
import CACHES_SHAPE from 'rlink-data-connector/storage/CACHES_SHAPE';
import _resolveValue from 'rlink-data-connector/storage/_resolveValue';
import config from 'rlink-debug-utils/config';
import _replaceEmbeddedValuesWithReferencesAndUpdateTheirDependenceis from 'rlink-data-connector/storage/_replaceEmbeddedValuesWithReferencesAndUpdateTheirDependenceis';
import animationFrame from 'rlink-await-animation-frame';
import _updateReferenceValues from 'rlink-data-connector/storage/_updateReferenceValues';
import _storeResolvedCaches from 'rlink-data-connector/storage/_storeResolvedCaches';



let pendingRipAndUpdateTasks = 0;

let resolvePhaseWorkBatch = {
  updateOps: [],
  updatedReferences: {},
};
function workBatchIsEmpty () {
  return resolvePhaseWorkBatch.updateOps.length === 0 && Object.keys(resolvePhaseWorkBatch.updatedReferences).length === 0;
}
let resolvePhaseIsActive = false;
function setupNextResolvePhaseCompletionPromise () {
  let resolveFunction;
  let promise = new Promise(resolve => {
    resolveFunction = resolve;
  });
  promise.markComplete = resolveFunction;
  return promise;
}
let completionOfNextResolvePhase = setupNextResolvePhaseCompletionPromise();

async function commitToResolvePhase (dispatch, getState, updateOpsForBatch, updatedReferencesForBatch) {
  // add to the work batch
  resolvePhaseWorkBatch.updateOps.push(...updateOpsForBatch);
  Object.assign(resolvePhaseWorkBatch.updatedReferences, updatedReferencesForBatch);

  if (pendingRipAndUpdateTasks > 0) {
    // do nothing
    // when the pending task resolves, our work is already in the batch to be processed
    // just wait for the next resolve phase until we return...
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.log(`... batched for next resolver (${pendingRipAndUpdateTasks} tasks waiting)`);
    }
    await completionOfNextResolvePhase;
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.groupEnd();
    }
  } else {
    while (resolvePhaseIsActive) {
      await completionOfNextResolvePhase;
    }
    if (workBatchIsEmpty()) {
      // someone else must have committed it
      // we're done :)
      if (config.LOG_STORE_VALUE_REDUCER) {
        console.log('... empty work batch - early exit');
        console.groupEnd();
      }
      return;
    }
    resolvePhaseIsActive = true;
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.group('RESOLVE PHASE');
    }
    let updateOps = resolvePhaseWorkBatch.updateOps;
    let updatedReferences = resolvePhaseWorkBatch.updatedReferences;
    resolvePhaseWorkBatch = {
      updateOps: [],
      updatedReferences: {},
    };

    inspectOps('updateOps', updateOps);
    let updatedCaches = CACHES_SHAPE.updateAt(getState().caches, updateOps);
    // now all the new reference values and update links have been updated
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.log('UPDATED CACHES:', updatedCaches);
    }

    await animationFrame();

    let resolveSet = {};
    for (let updatedRef of values(updatedReferences)) {
      resolveSet[updatedRef] = {resolveRef: updatedRef, isResolved: false};
      let updates = CACHES_SHAPE.getAt(updatedCaches,
          updatedRef.storagePath('updates'));
      for (let update of values(updates)) {
        resolveSet[update] = {resolveRef: update, isResolved: false};
      }
    }
    await animationFrame();

    let resolveOps = [];
    for (let {resolveRef} of values(resolveSet)) {
      let resolvedValue = _resolveValue(updatedCaches, resolveSet,
            CACHES_SHAPE.getAt(updatedCaches, resolveRef.storagePath('reference')));
      await animationFrame();
      resolveOps.push([
        resolveRef.storagePath('resolved'),
        operations.set,
        resolvedValue,
      ]);
    }
    await animationFrame();

    inspectOps('resolveOps', resolveOps);
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.groupEnd();
      console.groupEnd();
    }
    let resolvedCaches = CACHES_SHAPE.updateAt(updatedCaches, resolveOps);
    if (config.LOG_STORE_VALUE_REDUCER) {
      console.log('RESOLVED CACHES:', resolvedCaches);
    }
    await dispatch(_storeResolvedCaches(resolvedCaches));
    resolvePhaseIsActive = false;
    completionOfNextResolvePhase.markComplete();
    completionOfNextResolvePhase = setupNextResolvePhaseCompletionPromise();
  }

}



export default function storeEmbeddedValues (...embeddedValues) {
  if (config.LOG_STORE_VALUE_REDUCER) {
    console.group(`Reduce store embedded values: ${embeddedValues.join(',')}\n`, ...embeddedValues);
  }
  return async (dispatch, getState) => {
    pendingRipAndUpdateTasks++;
    let updateOps = [];
    let referencesAndValues = {};
    for (let embeddedValue of embeddedValues) {
      await animationFrame();
      updateOps.push(
        ..._replaceEmbeddedValuesWithReferencesAndUpdateTheirDependenceis(
          embeddedValue, referencesAndValues, getState().caches));
    }

    // set all the new reference values
    let updatedReferences = {};
    for (let [innerReference, referenceValue, meta]
        of Object.values(referencesAndValues)) {
      await animationFrame();
      updateOps.push(
        ..._updateReferenceValues(innerReference, referenceValue, meta,
          updatedReferences));
    }
    pendingRipAndUpdateTasks--;
    return await commitToResolvePhase(dispatch, getState, updateOps, updatedReferences);
  };
}

function inspectOps (heading, ops) {
  if (!config.LOG_STORE_VALUE_REDUCER) {
    return;
  }
  console.group(heading);
  for (let [path, op, value] of ops) {
    console.log(`${path.join('.')} ${op.toString()}`, value);
  }
  console.groupEnd();
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storeEmbeddedValues.js